import { type FC } from "react";

import { Alert } from "@snapchat/snap-design-system";

import { LensPlusRemovedTitle, LensPlusRemovedWarning } from "./messages.generated";

export const RemovedExclusiveLensAlert: FC = () => (
    <Alert status="warning" title={<LensPlusRemovedTitle />} description={<LensPlusRemovedWarning />} />
);
